import React, { MouseEvent, PureComponent } from "react";
import classnames from "classnames";

import * as styles from "./Only.scss";

interface IOnlyProps<T> {
    value: T;
    className?: string;
    onClicked: (value: T) => void;
}

export class Only<T> extends PureComponent<IOnlyProps<T>> {
    public render() {
        const { className } = this.props;
        return (
            <div
                onMouseDown={this.onMouseDown}
                className={classnames(styles.only, className)}
            >
                Only
            </div>
        );
    }

    private onMouseDown = (event: MouseEvent) => {
        const { value, onClicked } = this.props;
        event.preventDefault();
        event.stopPropagation();
        onClicked(value);
    };
}
